import { render, staticRenderFns } from "./LoadedChatFromQueueDialog.vue?vue&type=template&id=25e5f602&"
import script from "./LoadedChatFromQueueDialog.vue?vue&type=script&lang=ts&"
export * from "./LoadedChatFromQueueDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports